import styles from './index.scss'
import { Button } from 'antd-mobile'
import { useEffect, useState } from 'react'
import { couponListMyCoupon } from '@/services'
import Layout from '@/libs/components/Layout'
import { getUrlAllParams } from '@/libs/functions/getValue'
import DiscountCouponCard from '@/libs/components/DiscountCouponCard/disabled'
import Tabs from '@/libs/components/Tabs'

export default function HistoryDiscountCouponList() {
  const { category } = getUrlAllParams() as any
  const [listData, setListData] = useState<any>([])
  const [status, setStatus] = useState<any>('1')

  const tabsList: any = [
    {
      title: '已使用',
      value: '1',
    },
    {
      title: '已失效',
      value: '3',
    },
  ]

  const getListData = async () => {
    const res: any = await couponListMyCoupon({
      status: status,
    })
    setListData(res)
  }

  useEffect(() => {
    getListData()
  }, [status])

  return (
    <Layout title="历史优惠券">
      <div className={styles.historyDiscountCouponList}>
        <Tabs
          list={tabsList}
          onChange={(value: number) => {
            setStatus(value)
          }}
          value={status}
        />
        <div className={styles.listWrap}>
          {listData.length > 0 &&
            listData.map((v: any) => (
              <DiscountCouponCard key={v.id} data={v} />
            ))}
        </div>
        {listData.length === 0 && (
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            暂无历史优惠券
          </div>
        )}
      </div>
    </Layout>
  )
}
